module.exports = __webpack_public_path__ + "8f77a7e873b962b5221f09a8f15262a7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-s.png
// module id = 3131
// module chunks = 0